import React from 'react'
import ReportStandardUserListMobileTab from './ReportStandardUserListMobileTab'
import { buildReportRefundsUserMobileCardSections } from './reportRefundsUserMobileCardModel'

export default function ReportRefundsMobileTab(props) {
  return (
    <ReportStandardUserListMobileTab {...props} buildCardSections={buildReportRefundsUserMobileCardSections} />
  )
}
